<app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
<h4 class="title">Revise e assine o termo</h4>

<app-pdf-document class="documento" [src]="pdfSrc()"></app-pdf-document>

<div class="d-flex justify-content-center aceite">
  <vivest-checkbox
    label-variant="single-line"
    name="aceite-termo"
    required
    [checked]="aceiteTermo()"
    (change)="onAceiteChange($event)"
  >
    Li e estou de acordo
  </vivest-checkbox>
</div>

<div class="d-flex justify-content-center align-items-center buttons-requerimento">
  <vivest-button variant="outline" size="md" (click)="onReturn()">
    Voltar
  </vivest-button>
  <vivest-button
    variant="primary"
    size="md"
    [disabled]="!aceiteTermo() || assinando() || openModalSucesso()"
    (click)="onSubmit()"
  >
    <vivest-icon slot="icon-left" name="check-circle" source="feather"></vivest-icon>
    Assinar termo
  </vivest-button>
</div>

<!-- Aberto só depois que o envio da solicitação retorna sucesso. -->
<vivest-modal
  #modalSucesso
  heading="Solicitação enviada com sucesso!"
  description="Confira os detalhes no botão abaixo"
  [hasIcon]="true"
  [open]="openModalSucesso()"
  (vivest-close)="verDetalhes()"
  style="--vivest-color-text-heading: var(--vivest-color-text-success, #1b894a)"
>
  <img slot="icon" src="assets/images/icons/Check.svg" alt="" />
  <vivest-button slot="actions" variant="outline" size="md" (click)="verDetalhes()">Ver detalhes</vivest-button>
</vivest-modal>
